import { useState } from 'react';

import { Box, Button, Flex, Heading, Stack, Text } from '@chakra-ui/react';
import { ChevronDownIcon } from '@udacity/chakra-uds-icons';

import { Glyph } from '~/components/glyph';

const benefitsList = [
  { icon: 'trophy-one', text: 'Bootcamp level quality, at a fraction of the cost' },
  { icon: 'clock-twofourhr-one', text: 'Self-paced learning for your convenience' },
  { icon: 'person-group-three-one', text: 'Industry experts review your work' },
  { icon: 'person-laptop-one', text: 'Personalized career services' },
  { icon: 'robot-arm-one', text: 'Real projects you can add to your CV' },
] as const;

export function UdacityBenefitsSection() {
  return (
    <>
      <Box display={{ base: 'none', md: 'block' }}>
        <UdacityDesktopBenefitsSection />
      </Box>
      <Box display={{ base: 'block', md: 'none' }}>
        <UdacityMobileBenefitsSection />
      </Box>
    </>
  );
}

export function UdacityMobileBenefitsSection() {
  const [showAll, setShowAll] = useState<boolean>(false);
  return (
    <Flex alignItems={{ base: 'center', lg: 'unset' }} flexDirection='column'>
      <Heading as='h2' mb={4} size='marketing-xl'>
        Why Udacity?
      </Heading>

      <Stack spacing='8px'>
        {benefitsList.map((benefit, idx) => (
          <Box key={benefit.text} alignItems='center' display='flex' gap={4} hidden={showAll ? false : idx > 3}>
            <Box background='white' borderRadius='4px' flexShrink={0} padding='8px'>
              <Glyph height={48} name={benefit.icon} width={48} />
            </Box>
            <Text fontWeight='600'>{benefit.text}</Text>
          </Box>
        ))}
      </Stack>

      <Button
        alignSelf='center'
        hidden={showAll}
        marginTop='12px'
        rightIcon={<ChevronDownIcon height='24px' width='24px' />}
        variant='ghost'
        width='fit-content'
        onClick={() => setShowAll(true)}
      >
        See More
      </Button>
    </Flex>
  );
}

export function UdacityDesktopBenefitsSection() {
  return (
    <Flex alignItems={{ base: 'center', lg: 'unset' }} flexDirection='column'>
      <Heading as='h2' size='marketing-4xl'>
        Why Udacity?
      </Heading>

      <Stack marginTop='32px' spacing='16px'>
        {benefitsList.map((benefit) => (
          <Box key={benefit.text} alignItems='center' display='flex' gap={6}>
            <Box background='white' borderRadius='4px' flexShrink={0} padding='8px'>
              <Glyph height={40} name={benefit.icon} width={40} />
            </Box>

            <Heading as='p' size='marketing-xl'>
              {benefit.text}
            </Heading>
          </Box>
        ))}
      </Stack>
    </Flex>
  );
}
